import { render } from "./main.vue?vue&type=template&id=fc19b8da&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=fc19b8da&lang=scss&scoped=true"
import "./main.vue?vue&type=style&index=1&id=fc19b8da&lang=css"

import exportComponent from "C:\\development\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AdminUI\\admin-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc19b8da"]])

export default __exports__